// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EmptyResult__no-results-deaa3d {
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 0 16px;
  color: var(--base-80);
  font: var(--font-subtitle-4);
  letter-spacing: var(--font-spacing-subtitle-4);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  height: 100%;
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/SearchMessages/EmptyResult/EmptyResult.styles.m.css"],"names":[],"mappings":"AAAA;EACE,OAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,qBAAA;EACA,4BAAA;EACA,8CAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,YAAA;AACF","sourcesContent":[".no-results {\n  flex: 1;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  padding: 0 16px;\n  color: var(--base-80);\n  font: var(--font-subtitle-4);\n  letter-spacing: var(--font-spacing-subtitle-4);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  height: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"no-results": `EmptyResult__no-results-deaa3d`,
	"noResults": `EmptyResult__no-results-deaa3d`
};
module.exports = ___CSS_LOADER_EXPORT___;
